import { ref } from 'vue'
import { AccountGraph } from '@/components/graph-recomendations/types'

export const overrideQueryGraphs = ref<AccountGraph[]>([])
